/**
 * @file Transform component: where an entity is and which way it faces.
 */

import * as THREE from 'three';
import { Component } from '../ecs/Component.js';

export class Transform extends Component {
  /**
   * @param {number} [x] World X.
   * @param {number} [y] World Y (ground level is 0).
   * @param {number} [z] World Z.
   */
  constructor(x = 0, y = 0, z = 0) {
    super();
    /** @type {THREE.Vector3} World position. */
    this.position = new THREE.Vector3(x, y, z);
    /**
     * Position at the start of the frame, written by the movement system.
     * Swept collision and future render interpolation both read it.
     * @type {THREE.Vector3}
     */
    this.previousPosition = new THREE.Vector3(x, y, z);
    /** @type {number} Facing angle around Y, in radians. */
    this.rotationY = 0;
    /** @type {number} Uniform scale, mostly used by hit reactions. */
    this.scale = 1;
  }

  /** @returns {void} */
  reset() {
    this.position.set(0, 0, 0);
    this.previousPosition.set(0, 0, 0);
    this.rotationY = 0;
    this.scale = 1;
  }
}
